var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container-main bg-light" }, [
    _c("div", { staticClass: "form-row" }, [
      _c("div", { staticClass: "col-12 col-12 px-4 py-3" }, [
        _c("label", { staticClass: "mb-2" }, [
          _vm._v(
            "\n        " +
              _vm._s(
                _vm.$t("message.typedeletetoconfirm", { code: _vm.code })
              ) +
              "\n        "
          ),
          _vm.learnmoreLink
            ? _c(
                "a",
                { attrs: { href: _vm.learnmoreLink, target: "_blank" } },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("button.learnmore")) +
                      "\n          "
                  ),
                  _c("i", { staticClass: "fas fa-external-link-alt" })
                ]
              )
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.input,
              expression: "input"
            }
          ],
          staticClass: "form-control",
          class: _vm.inputClass,
          attrs: { type: "text" },
          domProps: { value: _vm.input },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.input = $event.target.value
            }
          }
        })
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4aec0588", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4aec0588","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/custom/TypeToConfirmDelete.vue
// module id = null
// module chunks = 